import ManageVendorCampaignPostsAdminPartial from "../../../../partials/admin/menus/vendors/manage-vendor-campaign-posts.admin.partial";

export default function ManageVendorCampaignPostsAdminScreen() {
  return <ManageVendorCampaignPostsAdminPartial />;
}
